import React from "react";
import { Box, List, Avatar, Typography } from "@mui/material";
import vsDarkTheme from "../theme/vsDarkTheme";
import MenuItem from "./MenuItem";
import SocialIcons from "./SocialIcons";

export default function DrawerContent({ onMenuItemClick }) {
  return (
    <>
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: vsDarkTheme.palette.primary.main }}>Victor Rios</Typography>
        <Avatar
          alt="Victor Rios Cartoon"
          src="/victor-cartoon.png"
          sx={{ width: 96, height: 96, margin: '16px auto' }}
        />
        <SocialIcons />
      </Box>
      <List>
        <MenuItem label="About" to="/" onClick={onMenuItemClick} />
        <MenuItem label="Resume" to="/resume" onClick={onMenuItemClick} />
        <MenuItem label="Blog & Projects" to="/blog" onClick={onMenuItemClick} />
      </List>
    </>
  );
}
